module.exports = __webpack_public_path__ + "img/logo-preto-raia.e58036c6.svg";